import React from "react";
import i18n from "../../../i18n/i18n";
import Report from "../report/report";
import {Utils} from "../../../helpers/utils";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {IPaginationStore} from "../../../common/stores/paginationStore";
import {storesContext} from "../../../common/stores/stores";
import {ValidatedValue} from "../../../helpers/validatedValue";
import {CargoType} from "../../../transportation/models/cargo";
import DateTimePicker from "../../../common/components/shared/dateTimePicker/dateTimePicker";
import Validator from "../../../helpers/validator";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import {CompanyModelForList} from "../../../dictionaries/models/company";
import {CompanyService} from "../../../dictionaries/services/companyService";
import {DropDownUtils} from "../../../helpers/dropDownUtils";
import Checkbox from "../../../common/components/shared/checkbox/checkbox";
import MultiSelectDropDown from "../../../common/components/shared/multiSelectDropDown/multiSelectDropDown";
import {DropDownModel} from "../../../common/models/dropDown";
import {TrailerBaseService} from "../../services/trailerBaseService";
import {DateUtils} from "../../../helpers/dateUtils";
import {TrailerBaseModel, TrailerBaseFilters} from "../../models/trailerBase";
import TextInput from "../../../common/components/shared/textInput/textInput";
import {FerryDropDownModel} from "../../../dictionaries/models/ferry";
import {RelationType} from "../../../transportation/models/relation";
import {FerryService} from "../../../dictionaries/services/ferryService";
import {TransportationService} from "../../../transportation/services/transportationService";
import {Api} from "../../../helpers/api";
import Loader from "../../../common/components/shared/loader/loader";
import { IUserStore } from "../../../administration/stores/userStore";

interface TrailerBaseState {
    selectedDepoEntryDateFrom: ValidatedValue<Date | null>;
    selectedDepoEntryDateTo: ValidatedValue<Date | null>;
    selectedDepoExitDateFrom: ValidatedValue<Date | null>;
    selectedDepoExitDateTo: ValidatedValue<Date | null>;
    selectedBookingDateFrom: ValidatedValue<Date | null>;
    selectedBookingDateTo: ValidatedValue<Date | null>;
    selectedCargoType: ValidatedValue<CargoType[] | []>;
    selectedShipper: ValidatedValue<string | "">
    selectedPaymentWaiver: ValidatedValue<boolean | false>;
    selectedFerry: ValidatedValue<string>
    selectedRelationType: ValidatedValue<string>
    selectedVoyageNo: ValidatedValue<string>
    isSubmitButtonBlocked: boolean;
    isReportGenerated: boolean;
    generatedReport: TrailerBaseModel[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    currentPage: number;
    companies: CompanyModelForList[];
    ferries: FerryDropDownModel[];
    relationTypes: RelationType[];
    ferriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    relationTypeResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    companiesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class TrailerBase extends React.Component <any, TrailerBaseState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            selectedDepoEntryDateFrom: new ValidatedValue(null),
            selectedDepoEntryDateTo: new ValidatedValue(null),
            selectedDepoExitDateFrom: new ValidatedValue(null),
            selectedDepoExitDateTo: new ValidatedValue(null),
            selectedBookingDateFrom: new ValidatedValue(null),
            selectedBookingDateTo: new ValidatedValue(null),
            selectedCargoType: new ValidatedValue([]),
            selectedShipper: new ValidatedValue(""),
            selectedPaymentWaiver: new ValidatedValue(false),
            selectedFerry: new ValidatedValue(""),
            selectedRelationType: new ValidatedValue(""),
            selectedVoyageNo: new ValidatedValue(""),
            isSubmitButtonBlocked: false,
            isReportGenerated: false,
            generatedReportResponse: undefined,
            generatedReport: undefined,
            currentPage: 0,
            companies: [],
            ferries: [],
            relationTypes: [],
            ferriesResponse: undefined,
            companiesResponse: undefined,
            relationTypeResponse: undefined
        };

        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
    }

    async componentDidMount() {
        await this.getFerries();
        await this.getCompanies();
        await this.getRelationType();
    }

    public render(): JSX.Element {
        const properties = ["relationType", "cargoType", "orderStatus", "ferryName",
            "shipownerName", "depoEntryDate", "depoExitDate", "bookingDate",
            "trailerRegNo", "lorryRegNo", "shipperName", "storageTime",
            "billableStorageTime", "parkingCost", "paymentMethod", "paymentWaiver",
            "weight", "securingDeclaration"];
        const headers = properties.map(key => i18n.t("reports.trailerBase.headers." + key));
        const isDataLoadedOrDataLoadError = (this.state.companies.length > 0 && this.state.ferries.length > 0 && this.state.relationTypes.length > 0) ||
        !Api.isSuccess(this.state.companiesResponse) || !Api.isSuccess(this.state.ferriesResponse) || !Api.isSuccess(this.state.relationTypeResponse);

        if (isDataLoadedOrDataLoadError) {
            return (
                <Report
                    className="trailer-base"
                    filters={this.renderFilters()}
                    onGenerateReport={this.onGenerateReport.bind(this)}
                    generatedReport={this.state.generatedReport}
                    generatedReportResponse={this.state.generatedReportResponse}
                    isReportGenerated={this.state.isReportGenerated}
                    reportTableRenderCell={this.renderCell.bind(this)}
                    reportTestId="trailer-base"
                    reportProperties={properties}
                    reportHeaders={headers}
                    currentPage={this.state.currentPage}
                    reportService={TrailerBaseService}
                    isSummaryReportGenerated={false}
                    selectedFilters={
                        {
                            depoEntryDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoEntryDateFrom.value),
                            depoEntryDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoEntryDateTo.value),
                            depoExitDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoExitDateFrom.value),
                            depoExitDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoExitDateTo.value),
                            bookingDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedBookingDateFrom.value),
                            bookingDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedBookingDateTo.value),
                            cargoType: this.state.selectedCargoType.value,
                            shipperId: this.state.selectedShipper.value,
                            paymentWaiver: this.state.selectedPaymentWaiver.value,
                            ferryEntityId: this.state.selectedFerry.value,
                            relationType: this.state.selectedRelationType.value,
                            voyageNo: this.state.selectedVoyageNo.value
                        } as TrailerBaseFilters
                    }
                    isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                    summaryCurrentPage={0}
                    summaryNumberOfElements={0}
                />
            );
        } else {
            return <Loader/>;
        }
    }

    private renderFilters(): JSX.Element {
        return (
            <>
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.depoEntryDateFrom")}
                    validatedValue={this.state.selectedDepoEntryDateFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepoEntryDateFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoEntryDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-depo-entry-date-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.depoEntryDateTo")}
                    validatedValue={this.state.selectedDepoEntryDateTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepoEntryDateTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoEntryDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-depo-entry-date-to"
                />
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.depoExitDateFrom")}
                    validatedValue={this.state.selectedDepoExitDateFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepoExitDateFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepoExitDateFrom, this.state.selectedDepoExitDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-depo-exit-date-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.depoExitDateTo")}
                    validatedValue={this.state.selectedDepoExitDateTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepoExitDateTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepoExitDateFrom, this.state.selectedDepoExitDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-depo-exit-date-to"
                />
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.bookingDateFrom")}
                    validatedValue={this.state.selectedBookingDateFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedBookingDateFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedBookingDateFrom, this.state.selectedBookingDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-booking-date-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.trailerBase.filters.bookingDateTo")}
                    validatedValue={this.state.selectedBookingDateTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedBookingDateTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedBookingDateFrom, this.state.selectedBookingDateTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedDepoEntryDateFrom, this.state.selectedDepoExitDateFrom, this.state.selectedBookingDateFrom);
                    }}
                    testId="filters-booking-date-to"
                />
                <MultiSelectDropDown
                    label={i18n.t("reports.trailerBase.filters.cargoType")}
                    items={this.cargoTypeToDropdown()}
                    validatedValue={this.state.selectedCargoType}
                    testId="filters-cargo-type"
                />
                <DropDown
                    label={i18n.t("reports.trailerBase.filters.shipper")}
                    items={this.companyToDropdown()}
                    validatedValue={this.state.selectedShipper}
                    testId="filters-shipper"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.companiesResponse) ? i18n.t("errorMessages.companiesErrorSuffix") : ""}
                    reloadFunc={() => this.getCompanies()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.trailerBase.filters.ferry")}
                    items={this.ferriesToDropdown()}
                    validatedValue={this.state.selectedFerry}
                    testId="filters-ferry"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.ferriesResponse) ? i18n.t("errorMessages.ferriesErrorSuffix") : ""}
                    reloadFunc={() => this.getFerries()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.trailerBase.filters.relationType")}
                    items={this.relationTypesToDropdown()}
                    validatedValue={this.state.selectedRelationType}
                    testId="filters-relation-type"
                    withEmptyValue
                    withoutSort
                    error={!Api.isSuccess(this.state.relationTypeResponse) ? i18n.t("errorMessages.relationTypeErrorSuffix") : ""}
                    reloadFunc={() => this.getRelationType()}
                    isNoRequired
                />
                <TextInput
                    label={`${i18n.t("reports.trailerBase.filters.voyageNo")}`}
                    validatedValue={this.state.selectedVoyageNo}
                    testId="filters-voyage-no"
                    onChange={() => {
                        this.state.selectedVoyageNo.clearValidation();
                    }}
                />
                <Checkbox
                    label={i18n.t("reports.trailerBase.filters.paymentWaiver")}
                    validatedValue={this.state.selectedPaymentWaiver}
                    testId="filters-payment-waiver"
                />
            </>
        );
    }

    private renderCell(row: any, property: string): JSX.Element {
        const userStore = this.context.userStore as IUserStore;

        switch (property) {
            case "depoEntryDate":
            case "depoExitDate":
            case "bookingDate":
                return <>{DateUtils.getFormattedDateWithTime((row[property]))}</>;
            case "relationType":
                return <>{i18n.t(`relationType.${row[property]}`)}</>;
            case "cargoType":
                return <>{i18n.t(`cargoType.${row[property]}`)}</>;
            case "paymentWaiver":
            case "securingDeclaration":
                return <>{Utils.renderBooleanYesNoValue(row[property], false)}</>;
            case "orderStatus":
                return <>{i18n.t(`orderStatus.${row[property]}`)}</>;
            case "paymentMethod":
                return row[property] && (<>{i18n.t(`paymentMethod.${row[property]}`)}</>);
            case "parkingCost":
                return row[property] && (<>{`${Utils.changePriceFormatByLanguage(row[property], userStore.language)}`}</>);
            default:
                return row[property];
        }
    }

    private companyToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.companies);
    }

    private ferriesToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.ferries, "entityId");
    }

    private relationTypesToDropdown() {
        let relationTypes = [] as DropDownModel[];
        if (Api.isSuccess(this.state.relationTypeResponse)) {
            relationTypes = this.state.relationTypes.map((element) => {
                return {
                    id: element,
                    name: i18n.t(`relationType.${element}`)
                };
            });
        }

        return DropDownUtils.listToDropDownMap(relationTypes);
    }

    private cargoTypeToDropdown(): DropDownModel[] {
        return [
            {
                id: "NORMATIVE_TRAILER", name: i18n.t("cargoType.NORMATIVE_TRAILER")
            },
            {
                id: "DANGEROUS_TRAILER", name: i18n.t("cargoType.DANGEROUS_TRAILER")
            }
        ];
    }

    private get isValid(): boolean {
        this.state.selectedDepoEntryDateFrom.validate();
        this.state.selectedDepoEntryDateTo.validate();
        this.state.selectedDepoExitDateFrom.validate();
        this.state.selectedDepoExitDateTo.validate();
        this.state.selectedBookingDateFrom.validate();
        this.state.selectedBookingDateTo.validate();
        this.state.selectedCargoType.validate();
        this.state.selectedShipper.validate();
        this.state.selectedPaymentWaiver.validate();
        this.state.selectedFerry.validate();
        this.state.selectedRelationType.validate();
        this.state.selectedVoyageNo.validate();

        return this.state.selectedDepoEntryDateFrom.isValid && this.state.selectedDepoEntryDateTo.isValid
            && this.state.selectedDepoExitDateFrom.isValid && this.state.selectedDepoExitDateTo.isValid
            && this.state.selectedBookingDateFrom.isValid && this.state.selectedBookingDateTo.isValid
            && this.state.selectedCargoType.isValid && this.state.selectedShipper.isValid && this.state.selectedPaymentWaiver.isValid
            && this.state.selectedFerry.isValid && this.state.selectedRelationType.isValid && this.state.selectedVoyageNo.isValid;
    }

    private async onGenerateReport() {
        this.setState({generatedReportResponse: undefined});
        const paginationStore = this.context.paginationStore as IPaginationStore;

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});

            const filters = {
                depoEntryDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoEntryDateFrom.value),
                depoEntryDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoEntryDateTo.value),
                depoExitDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoExitDateFrom.value),
                depoExitDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepoExitDateTo.value),
                bookingDateFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedBookingDateFrom.value),
                bookingDateTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedBookingDateTo.value),
                cargoType: this.state.selectedCargoType.value,
                shipperId: this.state.selectedShipper.value,
                paymentWaiver: this.state.selectedPaymentWaiver.value,
                ferryEntityId: this.state.selectedFerry.value,
                relationType: this.state.selectedRelationType.value,
                voyageNo: this.state.selectedVoyageNo.value.trim()
            };

            const generatedReportResponse = await TrailerBaseService.generateReport(
                filters
            );

            this.setState({
                isSubmitButtonBlocked: false,
                generatedReportResponse,
                generatedReport: generatedReportResponse?.data?.data || null,
                isReportGenerated: true,
                currentPage: generatedReportResponse?.data?.currentPage
            });

            paginationStore.setNumberOfElements(generatedReportResponse?.data?.numberOfElements);
            paginationStore.setNumberOfPages(generatedReportResponse?.data?.numberOfPages);
        }

        Utils.scrollToFirstErrorMessage();
    }

    private async getFerries() {
        const ferriesResponse = await FerryService.getFerriesForDropDown();

        this.setState({
            ferries: (ferriesResponse)?.data || [],
            ferriesResponse,
        });
    }

    private async getCompanies() {
        const companiesResponse = await CompanyService.getAll();

        this.setState({
            companies: (companiesResponse)?.data?.data || [],
            companiesResponse
        });
    }

    private async getRelationType() {
        const relationTypeResponse = await TransportationService.getAllRelationTypes();

        this.setState({
            relationTypes: (relationTypeResponse)?.data || [],
            relationTypeResponse
        });
    }
}